import { useEffect, useMemo } from "react";
import ReactPixel from "react-facebook-pixel";
import { connect } from "react-redux";

const Component = ({ group, post, subscription, groupStates, currentPage }) => {
  const pixelId: string = useMemo(() => {
    const resolvedPixelId =
      group?.expert?.account_fb_pixel_id ||
      subscription?.expert?.account_fb_pixel_id ||
      post?.group?.expert?.account_fb_pixel_id ||
      "";

    console.log("[Analytics] Resolved pixelId", {
      groupPixel: group?.expert?.account_fb_pixel_id,
      subscriptionPixel: subscription?.expert?.account_fb_pixel_id,
      postPixel: post?.group?.expert?.account_fb_pixel_id,
      resolvedPixelId,
      currentPage,
    });

    return resolvedPixelId;
  }, [group, subscription, post, currentPage]);

  const advancedMatching = undefined;
  const options = {
    autoConfig: true,
    debug: false,
  };

  const init = () => {
    console.log("[Analytics] Initializing Pixel", { pixelId });
    ReactPixel.init(pixelId, advancedMatching, options);
    ReactPixel.pageView();
    console.log("[Analytics] PageView fired", { pixelId });
  };

  useEffect(() => {
    const hasPixel = !!(
      group?.expert?.account_fb_pixel_id ||
      subscription?.expert?.account_fb_pixel_id ||
      post?.group?.expert?.account_fb_pixel_id
    );

    console.log("[Analytics] Checking pixel availability", {
      hasPixel,
      pixelId,
      groupId: group?.id,
      postId: post?.id,
      subscriptionId: subscription?.id,
    });

    if (hasPixel) {
      init();
    } else {
      console.warn("[Analytics] No pixel found", {
        group,
        post,
        subscription,
      });
    }
  }, [group, subscription, post, pixelId]);

  return <></>;
};

const state = ({ groupStore, postStore, pageStore, subscriptionStore }) => {
  const { name: currentPage } = pageStore;
  const { data: group, states: groupStates } = groupStore.group;
  const { data: post, states: postStates } = postStore.post;
  const { data: subscription, states: subscriptionStates } =
    subscriptionStore.userSubscription;


  return {
    group,
    groupStates,
    post,
    postStates,
    currentPage,
    subscription,
    subscriptionStates,
  };
};

export default connect(state)(Component);
